module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout",
    class: {
      'layout-hide-text': _vm.shrink
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('Col', {
    staticClass: "layout-menu-left"
  }, [_c('menu-lists', {
    attrs: {
      "shrink": _vm.shrink
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "layout-menu-right"
  }, [_c('div', {
    staticClass: "layout-header"
  }, [_c('div', {
    staticClass: "header-menu"
  }, [_c('Button', {
    staticClass: "menu-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [(_vm.shrink) ? _c('Icon', {
    attrs: {
      "type": "arrow-right-c",
      "size": "32"
    }
  }) : _c('Icon', {
    attrs: {
      "type": "navicon",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-panel"
  }, [_c('div', {
    staticClass: "header-panel-icon"
  }, [_c('message-tip', {
    model: {
      value: (_vm.mesCount),
      callback: function($$v) {
        _vm.mesCount = $$v
      },
      expression: "mesCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "header-panel-user"
  }, [_c('Dropdown', {
    staticClass: "header-dropdown",
    attrs: {
      "transfer": "",
      "trigger": "click"
    },
    on: {
      "on-click": _vm.handleDropdown
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-uid": _vm.userInfo.uid
    }
  }, [_vm._v("\n                " + _vm._s(_vm.userInfo.user) + "\n                "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "userCenter"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "logout"
    }
  }, [_vm._v("退出登录")])], 1)], 1), _vm._v(" "), _c('Avatar', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatarSrc
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-breadcrumb"
  }, [_c('Breadcrumb', _vm._l((_vm.currentPath), function(item, index) {
    return _c('BreadcrumbItem', {
      key: item.name,
      attrs: {
        "href": _vm.showHref(item, index)
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tags-wrap"
  }, [_c('tag-lists', {
    attrs: {
      "shrink": _vm.shrink,
      "offsetLeft": _vm.tagOffsetLeft
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-page"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a27d36f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/views/Admin.vue
// module id = jY36
// module chunks = 0